import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=20b0f815&"
import script from "./deleteModal.vue?vue&type=script&lang=js&"
export * from "./deleteModal.vue?vue&type=script&lang=js&"
import style0 from "./deleteModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports